import React, { useSyncExternalStore } from 'react'

import { SWRConfig } from 'swr'

import type { SessionCacheBoundary } from './sessionCacheBoundary'

const createSessionCache = () => new Map()

export default function SessionCacheProvider({
    boundary,
    children,
}: {
    readonly boundary: SessionCacheBoundary
    readonly children: React.ReactNode
}) {
    const generation = useSyncExternalStore(
        boundary.subscribe,
        boundary.getSnapshot,
    )

    // Retire both cached data and SWR's request/mutation scope. Outstanding
    // network operations may finish, but cannot populate the new session.
    return (
        <SWRConfig key={generation} value={{ provider: createSessionCache }}>
            {children}
        </SWRConfig>
    )
}
